<vw-toast-popup [isOpen]="isOpen" [title]="'calendar.climate.picker.title' | translate" (close)="onClose()">
  <div class="flex flex-col gap-4 px-4 pb-8">
    <!-- L'aide, en clair sous le titre (cible de 44 px), plutôt qu'un « i » de 16 px. -->
    <button data-testid="climate-picker-info-btn" (click)="infoClick.emit(); onClose()" type="button"
      class="-mt-2 flex min-h-target items-center gap-2 self-start text-body-s font-semibold text-vw-primary">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      {{ 'calendar.climate.info.title' | translate }}
    </button>

    <!-- Lignes de la feuille Langue (P2.1) : une section par famille, une ligne
         par climat avec son nombre de cultures, la coche sur le climat retenu.
         Ton climat garde sa mention dans sa ligne au lieu d'une ligne en plus ;
         une ligne « Ton climat » n'apparaît que s'il n'est pas dans la liste. -->
    @if (!myClimateListed) {
      <vw-list-section>
        <vw-list-row data-testid="climate-picker-reset" [attr.data-checked]="selectedClimateType === null"
          [title]="(myClimateType ? 'profile.addresses.climate-types.' + myClimateType : 'calendar.climate.myClimate') | translate"
          [subtitle]="myClimateType ? ('calendar.climate.myClimate' | translate) : ''"
          [chevron]="false" [checked]="selectedClimateType === null" (rowClick)="selectClimate(null)"></vw-list-row>
      </vw-list-section>
    }

    @for (group of groups; track group.key) {
      <vw-list-section [title]="familyKey(group.key) | translate">
        @for (climate of group.climates; track climate.climateType) {
          <vw-list-row [attr.data-testid]="'climate-option-' + climate.climateType" [attr.data-checked]="isChecked(climate.climateType)"
            [title]="'profile.addresses.climate-types.' + climate.climateType | translate"
            [subtitle]="climateSubtitle(climate)"
            [chevron]="false" [checked]="isChecked(climate.climateType)"
            (rowClick)="selectClimate(isMine(climate.climateType) ? null : climate.climateType)"></vw-list-row>
        }
      </vw-list-section>
    }
  </div>
</vw-toast-popup>
